/* eslint-disable */ 
import React, { Suspense } from "react"

// import BabylonScene from "./BabylonScene"
const BabylonScene = React.lazy(() => import('./BabylonScene'))

class Loader extends React.Component{
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		return (
			<div>
				<Suspense
					fallback={
						<div 
							className="parentLoaderDiv"
						>
							<div
								className="childLoaderDiv"
							>
								Loading...
							</div>
						</div>
					}
				>
					<BabylonScene />
				</Suspense>
			</div>
		)
	}
}

export default Loader